import React from 'react';
import { ChevronLeftUniversal, ChevronRightUniversal } from '@duxton-web/icons';

import '@/features/layout/main-menu-collapse/index.css';

interface MainMenuCollapseProps {
  collapsed: boolean;
  toggle?: () => void;
}

const MainMenuCollapse = ({
  collapsed,
  toggle = () => {},
}: MainMenuCollapseProps) => {
  return (
    <div
      data-testid="main-menu-collapse"
      className="collapsed-icon-wrapper"
      onClick={toggle}
    >
      <div className="collapsed-icon-container">
        {collapsed ? <ChevronRightUniversal /> : <ChevronLeftUniversal />}
      </div>
      {!collapsed && (
        <span className="collapsed-icon-title">Collapse menu</span>
      )}
    </div>
  );
};

export default MainMenuCollapse;
